import { tss } from 'tss-react/mui';

export const useStyles = tss.withName('ComponentsGridSpacer').create(() => ({
  root: {
    lineHeight: 1
  }
}));
